import React, { useContext } from 'react'
import { AdOrderContext } from '../../contexts/AdOrder'

export default function PriceSummary () {
  const { adOrder } = useContext(AdOrderContext)

  return (
    <aside className={'cart payment-summary'}>
      <h4>Kurv</h4>
      <ul className={'cart - items'}>
        <li>
          <span className={'label'}>Antal byportaler:</span>
          <span className={'value'}>{adOrder?.cities?.length ?? 0}</span>
        </li>
        <li>
          <span className={'label'}>Antal uger:</span>
          <span className={'value'}>{adOrder.weeks}</span>
        </li>
        <li>
          <span className={'label'}>Pris i alt:</span>
          <span className={'value'}>{adOrder.price} DKK ekskl. moms</span>
        </li>
      </ul>
    </aside>
  )
}